import { jsxs, jsx } from 'react/jsx-runtime';
import { useDate } from '@circlefin/hooks';

const ChatBubbleHeader = ({ children, date })=>{
    const { date: dateFormat } = useDate();
    return jsxs("div", {
        className: "cb-chat-bubble-header",
        children: [
            jsx("div", {
                className: "content",
                children: children
            }),
            jsx("div", {
                className: "date",
                children: dateFormat(date, 'timestamp')
            })
        ]
    });
};
ChatBubbleHeader.displayName = 'ChatBubbleHeader';

export { ChatBubbleHeader };
//# sourceMappingURL=ChatBubble.Header.es.js.map
